import DocumentDescriptionIcon from '@material-design-icons/svg/filled/description.svg?react';
import { useDappDataOptional } from '../../contexts/DappDataContext';
import { usePageTitle } from '../../hooks/usePageTitle';
import { useDappContext } from '../DappLayout';
import { DappLoadingState } from '../DappLoadingState';
import { DashboardHeader } from './DashboardHeader';
import { DashboardDetailsForm } from './details/components/DashboardDetailsForm';
import { DashboardDetailsSubmitButton } from './details/components/DashboardDetailsSubmitButton';
import { FORM_ID } from './details/constants';
import { useDashboardDetailsForm } from './details/hooks/useDashboardDetailsForm';

export const DashboardDetails = () => {
  const { dappId } = useDappContext();
  const { dappData } = useDappDataOptional();
  const dappName = dappData?.dappName || null;

  usePageTitle(
    dappId && dappName
      ? `${dappName} - Details | Publishing Portal`
      : 'Details | Publishing Portal',
  );

  const {
    isLoading,
    isSubmitting,
    isFormValid,
    hasChanges,
    isValidatingWallet,
    formData,
    previewDimensions,
    previewPanelData,
    dappPreviewUrls,
    resolvedDappIconUrl,
    resolvedBannerUrl,
    resolvedPreviewUrls,
    resolvedEditorsChoiceGraphicUrl,
    handleInputChange,
    handlePreviewFileChange,
    handleAddPreviewSlot,
    handleRemovePreviewSlot,
    handleSingleFileChange,
    handleSubmit,
    setIsFormValid,
    removeExistingDappIcon,
    removeExistingBanner,
    removeExistingPreview,
    removeExistingGraphic,
  } = useDashboardDetailsForm({
    dappId,
  });

  if (isLoading) {
    return <DappLoadingState />;
  }

  return (
    <div className="bg-[#161717] h-full flex flex-col">
      <DashboardHeader
        icon={<DocumentDescriptionIcon className="size-4 fill-white" />}
        title="Details"
        actions={
          <DashboardDetailsSubmitButton
            formId={FORM_ID}
            isSubmitting={isSubmitting}
            isValidatingWallet={isValidatingWallet}
            isFormValid={isFormValid}
            hasChanges={hasChanges}
          />
        }
      />

      <DashboardDetailsForm
        dappId={dappId}
        formData={formData}
        previewPanelData={previewPanelData}
        previewDimensions={previewDimensions}
        resolvedDappIconUrl={resolvedDappIconUrl}
        resolvedBannerUrl={resolvedBannerUrl}
        resolvedPreviewUrls={resolvedPreviewUrls}
        resolvedEditorsChoiceGraphicUrl={resolvedEditorsChoiceGraphicUrl}
        existingPreviewUrls={dappPreviewUrls}
        onValidityChange={setIsFormValid}
        onInputChange={handleInputChange}
        onPreviewChange={handlePreviewFileChange}
        onAddPreviewSlot={handleAddPreviewSlot}
        onRemovePreviewSlot={handleRemovePreviewSlot}
        onSingleFileChange={handleSingleFileChange}
        onRemoveExistingDappIcon={removeExistingDappIcon}
        onRemoveExistingBanner={removeExistingBanner}
        onRemoveExistingPreview={removeExistingPreview}
        onRemoveExistingGraphic={removeExistingGraphic}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
